import { images } from '../constants';

const activities = [
    {
        id: 1,
        image: images.activity1,
        title: 'Sightseeing',
        paragraphs: [
            "Discover iconic landmarks, hidden gems, and cultural treasures with our curated sightseeing tours. Whether you prefer historic sites, architectural marvels, or panoramic cityscapes, our tours are designed to offer you an immersive experience.",
            "Led by knowledgeable local guides, you'll gain fascinating insights, enjoy comfortable transportation, and have plenty of opportunities to capture unforgettable moments."
        ],
        gallery: [
            images.activity1Gallery1,
            images.activity1Gallery2
        ],
        highlights: [
            'Visit top attractions and must-see landmarks',
            'Guided tours with expert local storytellers',
            'Comfortable transport for hassle-free exploration',
            'Customizable itineraries for private groups',
            'Opportunities for photo stops and leisure time'
        ],
        requirements: [
            'Basic mobility for walking and sightseeing',
            'Comfortable walking shoes',
            'Weather-appropriate attire and sun protection',
            'Carry personal water bottles and essentials',
            'Adherence to group timings and guide instructions'
        ],
    },
    {
        id: 2,
        image: images.activity2,
        title: 'Desert Safari',
        paragraphs: [
            "Embark on an exhilarating desert safari adventure and experience the thrill of dune bashing across golden sands. Enjoy a journey that blends adrenaline-pumping activities with authentic cultural experiences in the heart of the desert.",
            "Our guided safaris offer a complete experience, including camel rides, traditional entertainment, and a sumptuous BBQ dinner under the starlit sky, making it an unforgettable escapade."
        ],
        gallery: [
            images.activity2Gallery1,
            images.activity2Gallery2
        ],
        highlights: [
            '4x4 dune bashing with professional drivers',
            'Camel rides and sandboarding experiences',
            'Traditional Bedouin-style desert camp',
            'Live cultural performances (Tanoura, Belly Dance)',
            'BBQ dinner with local and international cuisine'
        ],
        requirements: [
            'Suitable for ages 6 and above',
            'Wear comfortable and breathable clothing',
            'Closed-toe shoes recommended for desert activities',
            'Hydration essentials and sun protection advised',
            'Signed liability waiver required for dune bashing'
        ],
    },
    {
        id: 3,
        image: images.activity3,
        title: 'Cultural Exploration',
        paragraphs: [
            "Immerse yourself in the rich heritage, traditions, and local lifestyles through our Cultural Exploration tours. Visit historic landmarks, traditional markets, and artisan workshops to witness the vibrant culture up close.",
            "Led by local experts, these tours offer interactive experiences such as cooking classes, folk performances, and storytelling sessions that bring the culture and history to life."
        ],
        gallery: [
            images.activity3Gallery1,
            images.activity3Gallery2
        ],
        highlights: [
            'Guided visits to historic sites and cultural landmarks',
            'Hands-on activities like traditional cooking or crafts',
            'Explore local markets and interact with artisans',
            'Folk music and dance performances',
            'Insightful stories and legends from local guides'
        ],
        requirements: [
            'Comfortable walking shoes for exploration',
            'Respectful attire when visiting religious or sacred sites',
            'Willingness to participate in interactive activities',
            'Carry essentials like water, hat, and sunscreen',
            'Photography etiquette in cultural and private spaces'
        ],
    },
    {
        id: 4,
        image: images.activity4,
        title: 'Beach & Island Tours',
        paragraphs: [
            "Relax and unwind on pristine beaches and explore stunning islands with our curated Beach & Island Tours. Whether you're looking to soak up the sun, enjoy water activities, or discover hidden coves, these tours offer the perfect tropical escape.",
            "From leisurely beach strolls to exciting boat trips, experience the best of coastal beauty, crystal-clear waters, and vibrant marine life in a serene and picturesque setting."
        ],
        gallery: [
            images.activity4Gallery1,
            images.activity4Gallery2
        ],
        highlights: [
            'Visit to top-rated beaches and exotic islands',
            'Island-hopping tours with guided excursions',
            'Opportunities for swimming, snorkeling, and kayaking',
            'Relaxation spots with beach lounges and scenic views',
            'Optional seafood lunch at beachfront restaurants'
        ],
        requirements: [
            'Swimwear and beach-friendly clothing',
            'Sunscreen, sunglasses, and hats for sun protection',
            'Waterproof bags for personal belongings',
            'Follow safety instructions during water activities',
            'Basic swimming skills recommended for snorkeling'
        ],
    },
    {
        id: 5,
        image: images.activity5,
        title: 'Adventure & Hiking',
        paragraphs: [
            "Embark on thrilling adventure treks and hiking expeditions that take you through rugged terrains, scenic mountain trails, and breathtaking viewpoints. Whether you're a beginner or an avid trekker, our guided hikes offer routes suitable for every level of experience.",
            "Experience the great outdoors, discover hidden waterfalls, traverse through lush forests, and challenge yourself with nature’s finest landscapes, all while being guided by professional trek leaders."
        ],
        gallery: [
            images.activity5Gallery1,
            images.activity5Gallery2
        ],
        highlights: [
            'Guided treks through scenic and challenging trails',
            'Professional trekking guides ensuring safety and support',
            'Breathtaking viewpoints, waterfalls, and nature spots',
            'Flexible trail options from beginner to advanced levels',
            'Eco-conscious and sustainable trekking practices'
        ],
        requirements: [
            'Moderate physical fitness and endurance',
            'Sturdy hiking shoes or boots with good grip',
            'Weather-appropriate hiking attire and backpack',
            'Carry water bottles, snacks, and essentials',
            'Follow trail safety guidelines and group instructions'
        ],
    },
    {
        id: 6,
        image: images.activity6,
        title: 'Water Activities',
        paragraphs: [
            "Dive into excitement with a variety of thrilling water activities designed for adventure lovers and relaxation seekers alike. From adrenaline-pumping jet skiing and parasailing to peaceful paddleboarding and snorkeling, there’s something for everyone to enjoy.",
            "Our water activities are conducted with certified instructors ensuring safety, fun, and memorable aquatic adventures in crystal-clear waters and stunning beachside locations."
        ],
        gallery: [
            images.activity6Gallery1,
            images.activity6Gallery2
        ],
        highlights: [
            'Jet skiing, parasailing, and banana boat rides',
            'Guided snorkeling and underwater exploration',
            'Stand-up paddleboarding (SUP) and kayaking',
            'Certified instructors for beginner-friendly sessions',
            'All safety equipment and gear provided'
        ],
        requirements: [
            'Swimwear and beach-friendly attire',
            'Basic swimming ability recommended',
            'Follow safety instructions and wear life jackets',
            'Sun protection essentials (sunscreen, hats, sunglasses)',
            'Minimum age requirements for certain activities'
        ],
    }

];

export default activities;